import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputLabel,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState, useMemo } from "react";
import PickupLine from "../../Components/Warehouse/PickupLine";
import TableComponentPickup from "../../Components/TableComponentPickup";
import {
  Add,
  ArrowForward,
  DoneAll,
  Edit,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Save,
  
} from "@mui/icons-material";
import NotifyOrder from "../../Components/Warehouse/NotifyOrder";
import httpclient from "../../utils";
import MuiAlert from "@mui/material/Alert";
import { useNavigate, useParams } from "react-router-dom";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SearchBox = styled(Box)(({ theme }) => ({
  "& input": {
    // padding: "12px",
    width: "100%",
  },
}));

const columns = [
  //{ id: "check", name: " " },
  { id: "imageUrl", name: "Image" },
  { id: "ItemName", name: "Item" },
  { id: "EANBarcode", name: "Bar Code" },
  { id: "code", name: "Code" },
  { id: "SizeID", name: "Size" },
  { id: "quantity", name: "Quantity" },
  { id: "confirm", name: "Confirm" },
  // { id: "action", name: "Action" },
];

const columns1 = [

  { id: "imageUrl", name: "Image" },
  { id: "ItemName", name: "Item" },
  { id: "EANBarcode", name: "Bar Code" },
  { id: "code", name: "Code" },
  { id: "SizeID", name: "Size" },
  { id: "quantity", name: "Quantity" },
  { id: "confirm", name: "Confirm" },
  { id: "check", name: " " },
  // { id: "action", name: "Action" },
];


const ViewDialog = ({

  open,
  onClose,
  filteredData,
  columns,
  modifiedData,
  handleChange,
  handleAddQuantity,
  handleRemoveQuantity,
  handleRemoveFromCart,
  handleEdit,
  keyLoading,
  order,
  pickupOrder,
  fulfillState,
  handleReady

}) => {
 
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle sx={{ fontWeight: "600" }}>{"Edit Pickup Order"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item md={12}>
            <TableComponentPickup
              columns={columns}
              rows={filteredData || []}
              handleChange={handleChange}
              handleAddQuantity={handleAddQuantity}
              handleRemoveQuantity={handleRemoveQuantity}
              modifiedData={modifiedData}
              handleRemoveFromCart={handleRemoveFromCart}
            />
          </Grid>
          <Grid item md={12}>
            <Box textAlign={"right"} mb={2}>
              {/* {keyLoading ? (
                <CircularProgress />
              ) :
                (

                  <Button variant="contained" color="primary"
                    onClick={handleEdit}
                    disabled={modifiedData.some((mo) => mo.productQuantity === 0)}
                  >
                    <Save fontSize="small" style={{ marginRight: "5px" }} /> Save
                  </Button>
                )} */}
              &nbsp;&nbsp;&nbsp;
              {order?.number && pickupOrder && (

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleEdit}
                  disabled={modifiedData.some((mo) => mo.productQuantity === 0)}
                >
                  {/* {order?.customer?.email !== "" || order?.customer?.mobile !== "" ? "Notifiy and Ready to Fulfill" : "Ready to Fulfill"} */}
                  <Save fontSize="small" style={{ marginRight: "5px" }} />
                   Save and Ready to Fulfill
                  <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
                </Button>

              )}
            </Box>
          </Grid>
        </Grid>


      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const PickupList = ({
  pickupList,
  setPickupList,
  loading,
  pickupOrder,
  pickupOrder1,
  setPickupOrder,
  order,
  setOrder,
  setValue,
  orderList,
  expressList,
  orderDetail,
  orderName,
  setOrderName,
  handleOrderFilter,
  handleChangeOrder,
  handleOrderCodeFilter,
  handleRefresh,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [orderCode, setOrderCode] = useState("");
  const [codeName, setCodeName] = useState("");
  const [codeErr, setCodeErr] = useState(false);
  const [pickID, setPickID] = useState("");
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  var [modifiedData, setModifiedData] = useState([]);
  var [modifiedDataList, setModifiedDataList] = useState([]);

  const [check, setCheck] = useState(false);
  const [showNotifyDialog, setShowNotifyDialog] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});
  var [fulfillState, setFulFillState] = useState(false);

  const [open, setOpen] = useState(false);
  const [snackStatus, setSnackStatus] = useState("");
  const [snackMessage, setSnackMessage] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [dataModified, setDataModified] = useState(false);
  const [keyLoading, setKeyLoading] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [fromEdit, setFromEdit] = useState(false);
  //Mobile
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  useState(() => {
    setOpenFilter(false);
  }, []);

  // useEffect(() => {
  //   const pickupOrder = JSON.parse(localStorage.getItem("new-order"));

  //   if (pickupOrder) {

  //     // Update the "pickupList" state with the data from local storage
  //     setPickupList(pickupOrder?.sales_details || []);
  //     setPickupOrder(pickupOrder);
  //     setOrder(pickupOrder);
  //     setOrderDetails(pickupOrder);
  //     setOrderName(pickupOrder?.number);

  //   }

  // }, []);

  useEffect(() => {
    var allData = [];
    pickupList &&
      pickupList.map((pick, index) => {
        var newData = {
          productQuantity: fromEdit ? modifiedData[index].productQuantity : 0,
          check: false,
          id: pick.productID,
          price: pick.price,
        };
        allData.push(newData);
      });

    setModifiedData(allData);
    setFilteredData(pickupList);
    setFromEdit(false);
  }, [pickupList]);


  useEffect(() => {
    getFulfilledState();
    getModifiedState();
  }, [modifiedData, modifiedDataList]);

  const getFulfilledState = () => {
    if (modifiedData.length > 0) {
      for (let i = 0; i < pickupList.length; i++) {
        let modAmt = parseInt(pickupList[i].amount || pickupList[i].quantity);
        if (
          pickupList[i].productID !== modifiedData[i].id ||
          modAmt !== modifiedData[i].productQuantity
        ) {
          return setFulFillState(false);
        } else {
          setFulFillState(true);
        }
      }
    }
  };

  const getModifiedState = () => {
    if (modifiedData.length > 0) {
      modifiedData.map((mod, index) => {
        if (mod.productQuantity > 0) {
          setDataModified(true);
        }
      });
    }
  };


  const handleChange = (e, pick) => {
    let currValue;

    var res = modifiedData.filter((mod) => {
      if (mod.id == pick.productID) {
        if (e.target.value <= 0) {
          currValue = 0;
        } else if (e.target.value >= parseInt(pick.quantity || pick.amount)) {
          currValue = parseInt(pick.quantity || pick.amount);
        } else {
          currValue = e.target.value;
        }
        return (mod.productQuantity = parseInt(currValue));
      }
    });

    setModifiedDataList(res);

    getFulfilledState();
  };

  const handleAddQuantity = (pick) => {
    var res = modifiedData.filter((mod) => {
      if (mod.id == pick.productID) {
        return (mod.productQuantity =
          parseInt(pick?.quantity || pick?.amount) == mod.productQuantity
            ? mod.productQuantity
            : mod.productQuantity + 1);
      }
    });

    setModifiedDataList(res);

    getFulfilledState();
  };

  const handleAddQuantityEdit = (pick) => {
  
    var res = modifiedData.filter((mod) => {
      if (mod.id == pick.productID) {
        return (mod.productQuantity =
          // parseInt(pick?.quantity || pick?.amount) == mod.productQuantity
          //   ? mod.productQuantity
          //   :
          mod.productQuantity + 1);
      }
    });

    setModifiedDataList(res);

    //getFulfilledState();
  };

  const handleRemoveQuantity = (pick) => {
    var res = modifiedData.filter((mod) => {
      if (mod.id == pick.productID) {
        return (mod.productQuantity =
          mod.productQuantity > 0 ? mod.productQuantity - 1 : 0);
      }
    });

    setModifiedDataList(res);

    getFulfilledState();
  };

  const handleRemoveQuantityEdit = (pick) => {
    var res = modifiedData.filter((mod) => {
      if (mod.id == pick.productID) {
        return (mod.productQuantity =
          mod.productQuantity > 0 ? mod.productQuantity - 1 : 0);
      }
    });


    setModifiedDataList(res);

    //getFulfilledState();
  };

  const handleChangeOrderCode = (e) => {
    setOrderCode(e.target.value);
  };

  const handleChangeOrderEnter = (e) => {
    if (e.key === "Enter") {
      handleOrderCodeFilter(e.target.value);
    }
  };

  const handleOrderSubmit = (e) => {
    handleOrderCodeFilter(orderCode);
  };

  const handleChangeCode = (e) => {
    setCodeName(e.target.value);
  };

  const handleChangeEnter = (e) => {
    if (e.key === "Enter") {
      setCodeName(e.target.value);
      handleAdd();
    }
  };

  const handleAdd = () => {
    pickupList.map((pick) => {
      if (codeName === pick.code || codeName === pick.ax_relation?.EANBarcode) {
        var res = modifiedData.filter((mod) => {
          if (mod.id == pick.productID) {
            if (
              mod.productQuantity === parseInt(pick?.quantity || pick?.amount)
            ) {
              const vibrationSoundSrc =
                process.env.PUBLIC_URL + "/vibration.mp3";
              const audio = new Audio(vibrationSoundSrc);
              audio.play();
            }
            return (mod.productQuantity =
              parseInt(pick?.quantity || pick?.amount) == mod.productQuantity
                ? mod.productQuantity
                : mod.productQuantity + 1);
          }
        });

        setModifiedDataList(res);

        getFulfilledState();

        setCodeErr(false);

        setTimeout(() => {
          setCodeName("");
        }, 200);
      } else {
      }
    });
    let codeVals = pickupList.map((pick) => pick.code);
    let barCodes = pickupList.map((pick) => pick.ax_relation?.EANBarcode);

    if (barCodes.length) {
      if (barCodes.includes(codeName) || codeVals.includes(codeName)) {
      } else {
        const vibrationSoundSrc = process.env.PUBLIC_URL + "/vibration.mp3";
        const audio = new Audio(vibrationSoundSrc);
        audio.play();

        setCodeErr(true);

        setTimeout(() => {
          setCodeName("");
          setCodeErr(false);
        }, 1500);
      }
    }
  };

  const handlePickupAll = () => {
    var allData = [];

    // pickupList.map((pick) => {
    //   var newData = {
    //     productQuantity: parseInt(pick.amount || pick.quantity),
    //     check: false,
    //     id: pick.productID,
    //   };
    //   allData.push(newData);
    // });
    const filterID = filteredData.map((fil) => fil.productID);

    pickupList.map((pick, index) => {
      var newData = {
        productQuantity: filterID.includes(pick.productID)
          ? parseInt(pick.amount || pick.quantity)
          : 0,
        check: false,
        id: pick.productID,
      };
      allData.push(newData);
    });
    setModifiedData(allData);
  };

 

  const handleReady = () => {
    
    setOpenDialog(false);
    setShowNotifyDialog(true);
    setOrderDetails(order);
  };

  const callbackNotify = (call) => {
    // console.log('call back', call);
    // console.log('orderDetailsorderDetails',orderDetails);
    if (call.open === false && call.success === false) {
      setShowNotifyDialog(false);
      setOrderDetails({});
    }

    if (call.open === false && call.success === true) {
      setShowNotifyDialog(false);
      httpclient
        .get(
          orderDetails.customer.email !== "" ||
            orderDetails.customer.mobile !== ""
            ? `wms/fulfill/order?id=${orderDetails.id}&warehouseID=${id}&sendSms=${call.phoneValue ? 1 : 0}&sendEmail=${call.emailValue ? 1 : 0}`
            : `wms/fulfill/order?id=${orderDetails.id}&warehouseID=${id}`
        )
        .then(({ data }) => {
          if (data.success) {
            if (data.status === 200) {
              setOpen(true);
              setSnackStatus("success");
              setSnackMessage(data.message);
              setTimeout(() => {
                // setValue(0);
                //navigate(-1);

                setOrder([]);
                setModifiedData([]);
                setModifiedDataList([]);
                setFilteredData([]);
                setOrderName("");
                setOrderCode("");
                setSearchText("");
              }, 1500);
            }
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        })
        .catch((error) => {
          setOpen(true);
          setSnackStatus("error");
          setSnackMessage(error);
        });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleSearch1 = (e) => {
    setSearchText(e.target.value);
    var searchValue = e.target.value;

    var filtered = pickupList.filter((order, index) => {
      var itemName = order.itemName;
      return itemName.toLowerCase().match(new RegExp(searchValue, "g"));
    });

    setFilteredData(filtered);
  };

  const handleFilter = () => {
    setOpenFilter(!openFilter);
  };

  const checkDataModifed = (newValue) => {
    if (dataModified) {
      if (
        window.confirm(
          "This order has already been modifed. Are you sure you want to change the order?"
        )
      ) {
        handleOrderFilter(newValue);
        setTimeout(() => {
          setOpenFilter(false);
          setDataModified(false)
        }, 1000);
      }
    }
    else {
      handleOrderFilter(newValue);
      setOpenFilter(false);
    }
  };

  const handleClickOpenDialog = () => {
    setOpenDialog(true);

  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };


  const handleEdit = () => {

    setKeyLoading(true);
    var requestData = {
      type: "",
      warehouseID: id,
      customerID: order.customer?.customerID,
      salesDocumentID: order.salesDocumentID,
      paymentType: "",
      express: order.isExpress === 1 ? true : false,
      cartTotal: 0,
      isFinal: true,
      attributeName1: "SchoolName",
      attributeType1: "text",
      attributeValue1: "",
    };
    if (order.attributes !== null) {
      const schoolIDs = JSON.parse(order.attributes) // Extract all schoolIDs from cartItems

      requestData.attributeValue1 = schoolIDs[0]?.attributeValue;
    } else {
      requestData.attributeValue1 = ""
    }

    modifiedData.forEach((item, index) => {
      requestData[`productID${index + 1}`] = item.id;
      requestData[`amount${index + 1}`] = item.productQuantity === 0 ? 1 : item.productQuantity;
      requestData[`price${index + 1}`] = item.price;
      requestData[`discount${index + 1}`] = "0";
    });
    modifiedData.forEach((item, index) => {
      requestData.cartTotal += item.productQuantity === 0 ? 1 : item.productQuantity;
    });
    
    httpclient
      .post(`saveSalesOrder?env=TEST&erplyLogin=${1}`, requestData)
      .then(({ data }) => {
        if (data.status === 200) {
          //setOpenDialog(false);
          setOpen(true);
          setKeyLoading(false);
          setSnackStatus("success");
          setSnackMessage(data.message);

          setTimeout(() => {
            handleReady();
          }, 1000);
        }
        else {
          //setOpenDialog(false);
          setOpen(true);
          setSnackStatus("error");
          setSnackMessage(data.message);
          setKeyLoading(false);
        }
      });
    //}
  }

  const handleRemoveFromCart = (id) => {
  
    const confirmed = window.confirm(
      "Are you sure you want to delete this item from cart?"
    );

    if (confirmed) {
      const index = order.sales_details.findIndex(
        (item) => item.productID === id
      );


      if (index === -1) {
        return;
      }
      const newCartItems = [...order.sales_details];
      newCartItems.splice(index, 1);
  
      setOrder({ ...order, sales_details: newCartItems });
      
      // const updatedModifiedData = newCartItems.map((item) => ({
      //   productQuantity: modifiedData[index].productQuantity, 
      //   check: false,
      //   id: item.productID,
      //   price: item.price,
      // }));
      const updatedModifiedData = newCartItems.map((item) => {
        const matchingItem = modifiedData.find((m) => m.id === item.productID);
      
        return {
          productQuantity: matchingItem ? matchingItem.productQuantity : 0,
          check: false,
          id: item.productID,
          price: item.price,
        };
      });
      
      setFromEdit(true);
      setModifiedDataList(updatedModifiedData);
      setModifiedData(updatedModifiedData);
      setPickupList(newCartItems);
      setPickupOrder({ ...order, sales_details: newCartItems })
      setFilteredData(newCartItems);

      //getFulfilledState();

      setOpen(true);
      setSnackStatus("error");
      setSnackMessage("Item deleted from cart");
    }
  };

  const combinedList = useMemo(() => [...orderList, ...expressList], [orderList, expressList]);
 
   console.log("modified data is", modifiedData);
   console.log("order >", order);
   
  return (
    <div>
      <>
        <Box
          display={"flex"}
          alignItems={"center"}
          flexDirection={isMobile ? "column" : "row"}
          justifyContent={"space-between"}
          mb={3}
        >
          <Box flex={"1"}>
            {order.number === undefined
              ? "Please scan barcode slip order choose filter"
              : ""}
          </Box>
          <Box
            textAlign="center"
            display={"flex"}
            alignItems={"flex-end"}
            justifyContent={"center"}
            style={{ height: "auto", marginTop: "10px" }}
            flex="1"
          >
            {order.number === undefined ? (
              <Box display={"flex"}>
                <TextField
                  label="Order Code"
                  variant="outlined"
                  focused
                  // color={codeErr ? "error" : "primary"}
                  type="text"
                  value={orderCode}
                  onChange={handleChangeOrderCode}
                  onKeyDown={handleChangeOrderEnter}
                  fullWidth
                  autoFocus
                  inputProps={{
                    style: {
                      padding: 12,
                      width: 300,
                    },
                  }}
                />
                <Button
                  onClick={handleOrderSubmit}
                  color="primary"
                  variant="contained"
                >
                  Submit
                  {/* <ArrowForward /> */}
                </Button>
              </Box>
            ) : (
              <h2>
                {pickupOrder
                  ? `Pickup Order ${order.number !== undefined ? "#" + order.number : ""
                  }`
                  : "Pickup List"}
              </h2>
            )}
          </Box>
          <Box flex="1" textAlign={"right"}>
            <Button variant="contained" color="primary" onClick={handleFilter}>
              Filter{" "}
              {!openFilter ? (
                <KeyboardArrowDown fontSize="small" />
              ) : (
                <KeyboardArrowUp fontSize="small" />
              )}
            </Button>
          </Box>
        </Box>

        <Collapse in={openFilter}>
          <Box style={{ margin: "0 10px" }}>
            <Grid
              spacing={2}
              container
              style={{
                padding: "20px",
                border: "1px solid #f1f1f1",
                borderRadius: "5px",
                marginBottom: "20px",
              }}
            >
              <Grid item xs={12} md={6}>
                <InputLabel>Search</InputLabel>
                {/* <SearchBox display={"flex"}> */}
                <TextField
                  type="search"
                  variant="outlined"
                  name="searchText"
                  value={searchText}
                  onChange={handleSearch1}
                  // sx={{ width: "300px" }}
                  fullWidth
                />
                {/* </SearchBox> */}
              </Grid>
              <Grid item xs={12} md={6}>
                {pickupOrder ? (
                  <>
                    <InputLabel>Scan/Select Order Number</InputLabel>
                    <Autocomplete
                      disablePortal
                      inputValue={orderName}
                      options={combinedList.length > 0 ? combinedList : []}
                      getOptionLabel={(option) => option.number}
                      // sx={{ width: isMobile ? 290 : 500 }}
                      onChange={(event, newValue) => {
                        checkDataModifed(newValue);
                      }}
                      autoFocus
                      onFocus={(e) => e.target.select()}
                      // fullWidth
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          value={orderName || ""}
                          onChange={handleChangeOrder}
                          fullWidth
                          focused={openFilter}
                          autoFocus={openFilter}
                        />
                      )}
                    />
                  </>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Box>
        </Collapse>

        {order.number === undefined ? (
          ""
        ) : (
          <>
            <Box display={"flex"} mb={3}>
              <TextField
                label="Code"
                variant="outlined"
                focused
                disabled={openFilter}
                color={codeErr ? "error" : "primary"}
                type="text"
                value={codeName}
                onChange={handleChangeCode}
                onKeyDown={handleChangeEnter}
                fullWidth
                autoFocus={openFilter ? false : true}
              />
              <Button variant="contained" color="secondary" onClick={handleAdd}>
                <Add fontSize="small" style={{ marginRight: "5px" }} /> Add
              </Button>
            </Box>
           
            <Box textAlign={"right"} mb={2}>
              {/* <Button
                variant="contained"
                color="primary"
                onClick={handleDiscard}
              >
                <Undo fontSize="small" style={{ marginRight: "5px" }} />{" "}
                Discard Fulfillment
              </Button>
              &nbsp;&nbsp;&nbsp; */}
              {order?.payments.length === 0 && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleClickOpenDialog}
              >
                <Edit fontSize="small" style={{ marginRight: "5px" }} />{" "}
                Edit All
              </Button>
              )}
              &nbsp;&nbsp;&nbsp;
              <Button
                variant="contained"
                color="primary"
                onClick={handlePickupAll}
                disabled={pickupList.length > 0 ? false : true}
              >
                <DoneAll fontSize="small" style={{ marginRight: "5px" }} />{" "}
                Pickup All
              </Button>
            </Box>

            {!loading ? (
              <>
                <TableComponentPickup
                  columns={columns}
                  rows={filteredData || []}
                  handleChange={handleChange}
                  handleAddQuantity={handleAddQuantity}
                  handleRemoveQuantity={handleRemoveQuantity}
                  modifiedData={modifiedData}
                  setModifiedData={setModifiedData}
                  handleRemoveFromCart={handleRemoveFromCart}
                />
              </>
            ) : (
              <Box textAlign={"center"}>
                <CircularProgress />
              </Box>
            )}
          </>
        )}
      </>

      {order?.number && pickupOrder && (
        <Box mt={2} textAlign={"right"}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleReady}
            disabled={!fulfillState}
          >
            {/* {order?.customer?.email !== "" || order?.customer?.mobile !== "" ? "Notifiy and Ready to Fulfill" : "Ready to Fulfill"} */}
            Ready to Fulfill
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      )}

      {openDialog && (
        <ViewDialog
          open={openDialog}
          onClose={handleCloseDialog}
          columns={columns1}
          filteredData={filteredData || []}
          handleChange={handleChange}
          handleAddQuantity={handleAddQuantityEdit}
          handleRemoveQuantity={handleRemoveQuantityEdit}
          handleRemoveFromCart={handleRemoveFromCart}
          modifiedData={modifiedData}
          handleEdit={handleEdit}
          keyLoading={keyLoading}
          fulfillState={fulfillState}
          handleReady={handleReady}
          order={order}
          pickupOrder={pickupOrder}

        />
      )}
      {showNotifyDialog && (
        <NotifyOrder
          orderDetails={orderDetails}
          callbackNotify={callbackNotify}
        />
      )}

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open1}

      >
        <CircularProgress color="inherit" />
        <Typography variant="h6" component="div">
          &nbsp;&nbsp; Loading...
        </Typography>
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackStatus}
          sx={{ width: "100%", position: "relative", top: "40px" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default PickupList;
